import { render, staticRenderFns } from "./CurrentBonusCard.vue?vue&type=template&id=a34639ce&scoped=true&"
import script from "./CurrentBonusCard.vue?vue&type=script&lang=js&"
export * from "./CurrentBonusCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34639ce",
  null
  
)

export default component.exports